<template>
    <div class="box-content px-[8px] relative overflow-hidden pt-0">
        <div class="flex mb-2 gap-[8px] md:gap-3 w-fit mx-auto flex-row mt-4 md:mt-0 justify-center overflow-hidden bg-white relative z-10 px-2">
            <h3 class="mb-0 text-4xl lg:text-6xl text-prime-color text-center">Bản tin HUET</h3>
        </div>
        <div v-if="!loading" class="container">
            <multiselect class="mb-3 max-w-[250px] mx-auto" v-model="newsType" :options="options" track-by="type" label="type" placeholder="Tất cả danh mục"
                :clear-on-select="false" :close-on-select="true" :hide-selected="false" :show-labels="false"
                :internal-search="false" :multiple="false">
                <span slot="noResult">Không tìm thấy danh mục này</span>
                <span slot="noOptions">Danh sách trống</span>
                <template slot="option" slot-scope="{ option }">
                    <div class="option__desc">
                        <span class="option__small">
                            {{ option.type }}
                        </span>
                    </div>
                </template>
            </multiselect>
            <div v-if="rawData.length>0" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-[16px]">
                <div v-for="(news, index) in entries" :key="index">
                    <div class="bg-white w-full h-fit shadow-lg shadow-black relative">
                        <img :src="$addPrefix(news.image)" loading="lazy" class="w-full h-[200px] object-cover object-center cursor-pointer" alt="news-thumbnail" @click="pushNewsDetail(news._id)">
                        <div class="px-[8px] py-3 md:px-3 flex flex-col gap-2">
                            <h5 class="mb-0 font-semibold cursor-pointer truncate capitalize" @click="pushNewsDetail(news._id)">{{ news.name }}</h5>
                            <p class="line-clamp-2 w-full mb-0" v-html="news.description"></p>
                            <div class="flex justify-between">
                                <p class="mb-0 text-gray-400 font-semibold">{{ getDateTime(news.updatedAt) }}</p>
                                <p class="mb-0 pr-2 hover:text-prime-color cursor-pointer font-semibold" @click="pushNewsDetail(news._id)">Đọc ngay</p>
                            </div>
                        </div>
                        <b-badge variant="warning" class="absolute top-3 left-3"><h6 class="mb-0 font-semibold">{{ news.type }}</h6></b-badge>
                    </div>
                </div>
            </div>
            <div v-else>
                <p class="py-3 mx-auto font-medium uppercase text-center text-base md:text-lg text-black font-sans">Hiện tại chưa có tin tức gì!</p>
            </div>
            <div v-if="rawData.length > itemsPerPage" class="mt-4">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="rawData.length"
                    :per-page="itemsPerPage"
                    class="d-flex justify-center"
                ></b-pagination>
            </div>
        </div>
        <Loading v-else />
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapActions } from 'vuex';
import Loading from '@/components/loading'

export default {
    components: {
        Loading, Multiselect
    },
    data() {
        return {
            rawData: [],
            entries: [],
            loading: true,
            newsType: '',
            options: [
                {type: 'Tất cả danh mục'},
                {type: 'Thông báo'},
                {type: 'Sinh viên'},
                {type: 'Thời khóa biểu'},
                {type: 'Sự kiện'},
                {type: 'Học bổng'},
                {type: 'Hợp tác'},
            ],
            currentPage: 1,
            itemsPerPage: 12
        }
    },
    methods: {
        ...mapActions('news', ['GetNewsList']),
        async getEntry(type = ''){
            let response;
            if (type) {
                response = await this.GetNewsList(type)
            } else {
                response = await this.GetNewsList()
            }
            this.rawData = response.data.data
            await this.splicePerPage()
            this.loading = false
        },
        splicePerPage() {
            this.entries = this.rawData.slice((this.currentPage - 1) * this.itemsPerPage, (this.currentPage - 1) * this.itemsPerPage + this.itemsPerPage);
        },
        getDateTime(rawData) {
            return rawData.substring(8, 10) + '-' + rawData.substring(5, 7) + '-' + rawData.substring(0, 4)
        },
        pushNewsDetail(id) {
            this.$router.push({path: '/news/detail/' + id})
        }
    },
    created() {
        this.getEntry()
    },
    watch: {
        newsType: {
            handler: function () {
                this.currentPage = 1
                this.getEntry(this.newsType.type != 'Tất cả danh mục' ? this.newsType.type : '')
            }
        },
        currentPage: {
            handler: function () {
                this.splicePerPage()
            }
        }
    }
}
</script>
<style>
.multiselect__single {
    margin-bottom: 0;
}
</style>